module.exports = __webpack_public_path__ + "static/media/insturctor2.01b20b24.png";